<template>
<span>{{ laravelVersion }}</span>
</template>
<script>
import { first } from 'lodash'

export default {
  
  props: {
    software: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    laravelVersion() {
      let laravel = first(this.software.filter(software => software.name === 'Laravel'))
      if(laravel) {
        return laravel.installed.version.version_number
      }
      return '--'
    }
  }
}
</script>
